<template>
  <v-container>
    <base-sq-card
      flat
      title="Remove Login"
      class="ma-0"
    >
      <v-row
        v-if="!removeSuccess"
      >
        <v-col
          cols="12"
          class="text-center"
        >
          <span class="frm-textbox mb-1 mx-auto">Remove login '{{ user.email_address }}'?</span>
        </v-col>
      </v-row>
      <v-row
        class="mx-auto card-full-width"
      >
        <v-card
          v-if="formErrors.length > 0"
          flat
          class="mr-7"
        >
          <v-alert
            type="error"
            v-for="(e, i) in formErrors"
            :key="i"
          >
            {{ e }}
          </v-alert>
        </v-card>
        <v-card
          v-if="removeSuccess"
          flat
          class="card-full-width mx-auto"
        >
          <v-alert
            color="success"
            class="text-center"
          >
            Login {{ assignLoginRecipient }} successfully removed.
          </v-alert>
        </v-card>
      </v-row>
      <v-row
        v-if="removeSuccess"
        class="mx-auto card-full-width"
      >
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          class="mr-6"
          text
          @click="cancelForm"
        >
          Close
        </v-btn>
      </v-row>
      <v-row
        v-else
        class="mx-auto card-full-width"
      >
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          class="mr-6"
          text
          @click="cancelForm"
        >
          Cancel
        </v-btn>
        <v-btn
          color="red darken-1"
          class="mr-12"
          text
          @click="doRemoveLogin"
        >
          <v-icon>
            mdi-trash-can-outline
          </v-icon>
          Remove Login
        </v-btn>
      </v-row>
    </base-sq-card>
    <v-overlay :value="overlayDisplay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import basicMixin from '../../mixins/basic'
  import {
    _COMMIT_LOG, ACCT_REMOVE_LOGIN,
  } from '../../store/actions.types'

  export default {
    // events
    // formClosed
    name: 'AccountAssignLogin',

    mixins: [basicMixin],

    props: {
      user: {
        type: Object,
        default: () => ({
          rowkey: null,
          email_address: null,
        }),
      },
    },
    data: () => ({
      formErrors: [],
      removeSuccess: false,
      overlayAbsolute: true,
      overlayDisplay: false,
      dlgAddLogin: false,
      assignLoginRecipient: '',
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'profile', 'apTypes', 'apStatuses', 'towers', 'optsBillingFreq', 'acctSelectedAccount']),
    },
    watch: {
    },
    created () {
      this.init()
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        removeLogin: ACCT_REMOVE_LOGIN,
      }),
      async init () {
        this.commitLog({ message: `Initializing ${name} setting values!` })
      },
      cancelForm () {
        this.resetForm()
        this.$emit('closeForm')
      },
      resetForm () {
        this.removeSuccess = false
        this.formErrors = []
        this.overlayDisplay = false
        this.assignLoginRecipient = ''
      },
      async doRemoveLogin () {
        this.overlayDisplay = true
        try {
          const postPayload = {
            login: this.user.email_address,
            account_key: this.acctSelectedAccount.rowkey,
          }
          const { data } = await this.removeLogin(postPayload)
          this.$emit('loginRemoved')
          this.commitLog({ message: 'remove-login request response', data })
          this.removeSuccess = true
        } catch (e) {
          this.commitLog({ message: 'Exception thrown assign-login form', error: e })
        }
        this.overlayDisplay = false
      },
    },

  }
</script>
